import styled from 'styled-components';
import { ColorConstants } from '@shared/constants';

export const AccountInfoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    
    & > div{
        margin-right: 25px;
    }
`;

export const AccountInfoTitle = styled.div`
    color: ${ColorConstants['regal-blue-50%']};
    font-size: 14px;
    text-align: right;
    font-family: 'Helvetica';
`;
